module.exports = __webpack_public_path__ + "media/assets/images/blog/matrioshka-be90b393bc1754e8ca0f805d840e06c1.jpg";